import { render, staticRenderFns } from "./boxshippingmark.vue?vue&type=template&id=7b4f1dd0&scoped=true&"
import script from "./boxshippingmark.vue?vue&type=script&lang=js&"
export * from "./boxshippingmark.vue?vue&type=script&lang=js&"
import style0 from "./boxshippingmark.vue?vue&type=style&index=0&id=7b4f1dd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4f1dd0",
  null
  
)

export default component.exports